setTimeout(function() {    
	if (jQuery(window).width() < 768) {
		jQuery('.footer-content .shopify-block-menu').each(function() {
			jQuery(this).parent().addClass('menu_block');
			jQuery(this).find('ul').addClass('mobile_hidden')
		}).on('click', function(e) {
			jQuery(this).find('ul').slideToggle();
            jQuery(this).find('.logo_url').slideToggle()
		})
      document.querySelector('.footer-content .shopify-block-menu ul').classList.remove('mobile_hidden');
      if(document.querySelector('.logo_url')) document.querySelector('.logo_url').classList.remove('mobile_hidden');
	}
	if (jQuery(window).width() < 768) {
		if (document.querySelectorAll('.size-swatch').length <= 3) {
			return;
		}
		document.querySelectorAll('.size-swatch').forEach(function(ele, index) {
			ele.classList.remove('mr-2');
			ele.classList.add('mr-1');
			ele.querySelector('label').classList.remove('tw-px-4', 'tw-h-11');
			ele.querySelector('label').classList.add('tw-px-3', 'tw-h-9');
			ele.querySelector('label').style.fontSize = '13px';
		});
	}  
});


if(Avatar.theme.current.pageType == "product"){
  let singleProductPage = document.querySelector('[data-section-type="product-template"]');
  let singleProductForm = singleProductPage.querySelector('form[action="/cart/add"]');
  let upsellCheckBox = document.getElementById('upsell-checkbox');
  let priorityCheckbox = document.getElementById('priority-checkbox');
  // show popup
  document.querySelectorAll(".popup_link").forEach(function(popup_link) {
      popup_link.addEventListener('click', function(){
        var model = popup_link.dataset.model;
        document.getElementById(model).style.display = "block";
      });
  });
  //hide popup
  document.querySelectorAll('.close').forEach(function(clsBtn){
    clsBtn.addEventListener('click', function(){
      clsBtn.parentElement.parentElement.style.display = 'none';
    })
  });
  // popUp add to cart 
  document.querySelectorAll('.popupBtn').forEach(function(popupBtn){
    popupBtn.addEventListener('click', function(evt) {
      evt.preventDefault();
      var popupItem = popupBtn.dataset.pid;
      document.querySelector('input[data-id="'+popupItem+'"]').checked = true;
      document.querySelector('input[data-id="'+popupItem+'"]').dispatchEvent(new Event('change'));
      document.getElementById(popupBtn.dataset.model).style.display = 'none';
      singleProductForm.querySelector('button[type="button"].product-button').click();
    });
  });
  // window clikc close popup
  window.addEventListener('click', function(evt) {
    if(evt.target == document.getElementById('upsellModel')){
      document.getElementById('upsellModel').style.display = 'none';
    }
    if(evt.target == document.getElementById('priorityModel')){
      document.getElementById('priorityModel').style.display = 'none';
    }
  });
  
  document.querySelectorAll('.custom-addons input').forEach(function (ele, idx){
    ele.addEventListener('change', function(){
      var is_checked = false;
      document.querySelectorAll('.custom-addons input').forEach(function(ele, idx){
        if( ele.checked) is_checked = true;
      });
      if(is_checked){
        singleProductForm.querySelector('button.product-button').setAttribute('type', 'button');
        singleProductForm.querySelector('button[type="button"].product-button').addEventListener('click', function(evt) {
          
          if( singleProductForm.dataset.ajaxSubmit == 'true'){
              let data = {
                items: [],
              };
              //prepare cart obj
              let customAddonCheckboxes = document.querySelectorAll('.custom-addons input[type="checkbox"]');
              customAddonCheckboxes.forEach(function(checkBox){
                if (checkBox.checked) {
                  data.items.push({
                    id: parseInt(checkBox.dataset.id),
                    quantity: 1,
                  });
                }
              });
              // product Obj
              var pQty = singleProductForm.querySelector(`input[name="quantity"]`);
              let productobj = {
                id: parseInt(singleProductForm.querySelector('input[name="id"]').value),
                quantity: parseInt(pQty ? pQty.value : 1)
              };
              data.items.push(productobj);
              // ajax method
              fetch('/cart/add.js', {
                method: 'POST',
                body: JSON.stringify(data),
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              .then(response => response.json())
              .then(function(data){
                
                if(data.status === 422){
                  alert(data);
                }else{   
                  Avatar.theme.sections.SliderCart.instance.openSliderCart();
                  Avatar.theme.sections.SliderCart.instance.refreshCartSlider();
                }
              });            
            }else{
              let productArr = [];
              let url   = 'https://www.ourtruegod.com/cart/add?';
              evt.preventDefault();
              if(upsellCheckBox && upsellCheckBox.checked){
                productArr.push(upsellCheckBox.dataset.id);
              }
              if(priorityCheckbox && priorityCheckbox.checked){
                productArr.push(priorityCheckbox.dataset.id);
              }
              var proId = singleProductForm.querySelector('.product-variant').value;
              var qty   = singleProductForm.querySelector('.product-quantity-input').value;
              url   += 'items[0][id]='+proId+'&items[0][quantity]='+qty;
              var count = 1;
              productArr.forEach(function (ele, id){
                url   += '&items['+count+'][id]='+ele+'&items['+count+'][quantity]=1';
                count++;
              });
              window.location.href = url;
            }// end of if           
        });
      }else{
        singleProductForm.querySelector('button.product-button').setAttribute('type', 'submit');
        console.log('clicked...')
      }
    });    
  });  
  
  
}